import { PageLoader, type Jobs } from '@seek/libs-shared';
import { useEffect, useState } from 'react';
import { useParams, useRouteLoaderData } from 'react-router';
import { CompanyProfilesPage } from '../../../paths';
import { useService } from '../../../shared/providers/serviceProvider';
import { SeoStructuredData } from '../../components/seoStructuredData/SeoStructuredData';
import { OPEN_JOBS_LISTING_SIZE_FOR_SALARIES } from './salariesLoader';
import { SalariesPage } from './SalariesPage';
import { SalariesPageByRole } from './SalariesPageByRole';
import type { SalariesTabModel } from './salariesTabModel';

interface SalariesPageContainerProps {
  trackJobsPaginationClicked: ({
    searchTotalCount,
    pageNumber,
  }: {
    pageNumber: number;
    searchTotalCount?: number;
  }) => void;
}

export const SalariesPageContainer = ({
  trackJobsPaginationClicked,
}: SalariesPageContainerProps) => {
  const { companyProfileService } = useService();
  const salariesHubPageModel = useRouteLoaderData<SalariesTabModel>(
    CompanyProfilesPage.Salaries,
  );
  const salariesRolePageModel = useRouteLoaderData<SalariesTabModel>(
    CompanyProfilesPage.SalariesRole,
  );

  const [model, setModel] = useState<SalariesTabModel | undefined>();
  const params = useParams();
  const isSalariesHubRoute = params.roleAlias === undefined;

  useEffect(() => {
    if (isSalariesHubRoute) {
      setModel(salariesHubPageModel);
    } else {
      setModel(salariesRolePageModel);
    }
  }, [isSalariesHubRoute, salariesHubPageModel, salariesRolePageModel]);

  const getPaginatedJobs = async (
    organisationId: string,
    page?: number,
  ): Promise<Jobs> => {
    const res = await companyProfileService.getJobs(
      organisationId,
      page,
      OPEN_JOBS_LISTING_SIZE_FOR_SALARIES,
    );
    return res;
  };

  return model ? (
    <>
      {/* TODO: SEO logic here */}
      <SeoStructuredData />
      {isSalariesHubRoute ? (
        <SalariesPage
          model={model}
          getPaginatedJobs={getPaginatedJobs}
          trackJobsPaginationClicked={trackJobsPaginationClicked}
        />
      ) : (
        <SalariesPageByRole
          model={model}
          getPaginatedJobs={getPaginatedJobs}
          trackJobsPaginationClicked={trackJobsPaginationClicked}
        />
      )}
    </>
  ) : (
    <PageLoader />
  );
};
